import GroupItem from "./group-item"

var AdditionalPlaces = React.createClass({
  render: function(){
    var that = this;
    var places = this.props.places;
    var items = [];
    var dayIndex = 0;
    var dayTitle =  'Alternatives to consider';

    if (!places || places.length === 0) return null;
    
    places.forEach(function(place, i){
      items.push(<GroupItem key={i} item={place} dayIndex={dayIndex} isSmallScreen={that.props.isSmallScreen} autoImageUrls={ that.props.autoImageUrls } />);
    });

    return (
      <div className="day additional-places">
        <h2>{dayTitle}</h2>
        <div className="items">
          { items }
        </div>
      </div>
    );
  }
});

module.exports = AdditionalPlaces;


// WEBPACK FOOTER //
// ./components/guide-components/additional-places.js